(() => {
  const money = (cents, currency) => new Intl.NumberFormat('en-CA', { style: 'currency', currency }).format(cents / 100);

  const initHero = (root) => {
    if (root.dataset.c2heroReady === 'true') return;
    root.dataset.c2heroReady = 'true';
    const currency = root.dataset.currency || 'CAD';
    const servings = Number(root.dataset.servings || 30);
    const quantityInputs = [...root.querySelectorAll('[data-c2hero-quantity]')];
    const planInputs = [...root.querySelectorAll('[data-c2hero-plan]')];
    const tiers = root.querySelector('[data-c2hero-tiers]');
    const formQuantity = root.querySelector('[data-c2hero-form-quantity]');
    const formPlan = root.querySelector('[data-c2hero-form-plan]');
    const price = root.querySelector('[data-c2hero-price]');
    const unit = root.querySelector('[data-c2hero-unit]');
    const selection = root.querySelector('[data-c2hero-selection]');
    const atcCopy = root.querySelector('[data-c2hero-atc-copy]');
    const productForm = root.querySelector('[data-c2hero-product-form] form');

    const refreshPurchase = () => {
      const quantityInput = quantityInputs.find((input) => input.checked) || quantityInputs[0];
      const planInput = planInputs.find((input) => input.checked) || planInputs[0];
      const isSubscription = Boolean(planInput?.value);
      const quantity = isSubscription
        ? Number(planInput?.dataset.planQuantity || 1)
        : Number(quantityInput?.value || 1);
      const discount = isSubscription ? 0 : Number(quantityInput?.dataset.discount || 0);
      const basePrice = Number(planInput?.dataset.planPrice || root.dataset.basePrice || 0);
      const total = Math.round(basePrice * quantity * (100 - discount) / 100);
      const totalServings = servings * quantity;
      const perServing = Math.round(total / totalServings);
      const interval = planInput?.dataset.planInterval || '';
      const pouchLabel = quantity === 1 ? 'pouch' : 'pouches';
      quantityInputs.forEach((input) => input.closest('label')?.classList.toggle('is-selected', input === quantityInput));
      planInputs.forEach((input) => input.closest('label')?.classList.toggle('is-selected', input === planInput));
      if (tiers) tiers.hidden = isSubscription;
      if (formQuantity) {
        formQuantity.name = 'quantity';
        formQuantity.value = String(quantity);
      }
      if (formPlan) formPlan.value = planInput?.value || '';
      if (price) price.textContent = money(total, currency);
      if (unit) unit.innerHTML = `${totalServings} servings · <b>${money(perServing, currency)}</b>/serving`;
      if (selection) {
        selection.textContent = isSubscription
          ? `${quantity} ${pouchLabel} per shipment · ${totalServings} servings · Delivered every ${interval} · ${money(total, currency)}/shipment`
          : `${quantity} ${pouchLabel} · ${totalServings} servings · ${money(perServing, currency)}/serving`;
      }
      if (atcCopy) {
        atcCopy.textContent = isSubscription
          ? `SUBSCRIBE · ${quantity} ${pouchLabel.toUpperCase()} EVERY ${interval.toUpperCase()} · ${money(total, currency)}`
          : `ADD ${quantity} ${pouchLabel.toUpperCase()} TO CART · ${money(total, currency)}`;
      }

      const stickyPrice = isSubscription ? `${money(total, currency)} / ${interval}` : money(total, currency);
      const stickyButtonText = isSubscription ? 'Subscribe' : 'Add to cart';
      root.dataset.c2heroStickyPrice = stickyPrice;
      root.dataset.c2heroStickyButton = stickyButtonText;
      window.dispatchEvent(new CustomEvent('c2hero:purchase-change', {
        detail: { productHandle: root.dataset.productHandle, stickyPrice, buttonText: stickyButtonText }
      }));
    };
    quantityInputs.forEach((input) => input.addEventListener('change', refreshPurchase));
    planInputs.forEach((input) => input.addEventListener('change', refreshPurchase));
    productForm?.addEventListener('submit', () => {
      const quantityInput = quantityInputs.find((input) => input.checked) || quantityInputs[0];
      const planInput = planInputs.find((input) => input.checked) || planInputs[0];
      productForm.querySelectorAll('input[name="selling_plan"]').forEach((input) => {
        if (input !== formPlan) input.removeAttribute('name');
      });
      if (formQuantity) {
        formQuantity.name = 'quantity';
        formQuantity.value = planInput?.value ? (planInput.dataset.planQuantity || '1') : (quantityInput?.value || '1');
      }
      if (formPlan && planInput?.value) {
        formPlan.name = 'selling_plan';
        formPlan.value = planInput.value;
      } else if (formPlan) {
        formPlan.removeAttribute('name');
        formPlan.value = '';
      }
    }, true);

    const viewport = root.querySelector('[data-c2hero-gallery-viewport]');
    const track = root.querySelector('[data-c2hero-gallery-track]');
    const slides = [...root.querySelectorAll('[data-c2hero-gallery-slide]')];
    const thumbs = [...root.querySelectorAll('[data-c2hero-gallery-thumb]')];
    const status = root.querySelector('[data-c2hero-gallery-status]');
    const setGallery = (index) => {
      const slide = slides[index];
      if (!slide || !track) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === index);
        thumb.setAttribute('aria-pressed', String(thumbIndex === index));
      });
      if (status) status.textContent = `${index + 1} / ${slides.length}`;
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => setGallery(Number(thumb.dataset.c2heroGalleryThumb))));
    if (track && slides.length > 1) {
      let scrollTimer;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          const index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, viewport?.clientWidth || track.clientWidth))));
          thumbs.forEach((thumb, thumbIndex) => {
            thumb.classList.toggle('is-active', thumbIndex === index);
            thumb.setAttribute('aria-pressed', String(thumbIndex === index));
          });
          if (status) status.textContent = `${index + 1} / ${slides.length}`;
        }, 90);
      }, { passive: true });
    }
    refreshPurchase();
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-c2hero-root]').forEach(initHero);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

